<template>
  <widget-template-card
    :template="template"
    :is_selected="is_selected"
    :compose_preview_settings="composePreviewSettings"
    :build_src="buildIframeSrc"
    :send_settings="sendSettingsToWidget"
    :send_autofill_test_data="sendAutoFillTestData"
    :widget_props="widget_props"
    preview_mode="tablet-landscape"
    current_page="form"
    preview_area_class="order-confirmation-preview-area"
    :height="height_based_on_layout"
    @select="$emit('select', template)"
  />
</template>

<script>
import WidgetTemplateCard from '@/components/widget/widget-template-card.vue';
import { buildWidgetIframeSrc, sendSettingsToWidget, sendAutoFillTestData } from '@/js/widget/widget-preview.js';
import { composeOrderConfirmationPreviewParams } from '@/js/widget/order-confirmation-preview-composer.js';

/**
 * Order Confirmation Template Card
 *
 * Displays a preview of an order confirmation template in a card format.
 * Used in template galleries for template selection.
 */
export default {
  name: 'mOrderConfirmationTemplateCard',

  components: {
    WidgetTemplateCard,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },

    is_selected: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: Object,
      default: () => ({}),
    },

    organization_name: {
      type: String,
      default: 'Your Organization',
    },

    background_image_url: {
      type: String,
      default: null,
    },

    side_image_url: {
      type: String,
      default: null,
    },

    logo_url: {
      type: String,
      default: null,
    },

    use_logo: {
      type: Boolean,
      default: false,
    },

    order_confirmation_settings: {
      type: Object,
      default: () => ({}),
    },

    comp_custom_fonts: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // side-by-side layouts need a bit more height at this scale
      layout_heights: {
        'side-by-side': 1400,
        'single-column': 1200,
      },
    };
  },

  computed: {
    widget_props() {
      return {
        theme: this.theme,
        organization_name: this.organization_name,
        background_image_url: this.background_image_url,
        side_image_url: this.side_image_url,
        logo_url: this.logo_url,
        use_logo: this.use_logo,
        order_confirmation_settings: this.order_confirmation_settings,
        comp_custom_fonts: this.comp_custom_fonts,
        is_test_submission: true,
      };
    },

    layout_mode() {
      return this.template?.template_overrides?.layout_mode || 'single-column';
    },

    height_based_on_layout() {
      return this.layout_heights[this.layout_mode] || null;
    },
  },

  methods: {
    composePreviewSettings(props) {
      return composeOrderConfirmationPreviewParams(props);
    },

    buildIframeSrc(preview_mode, is_development) {
      return buildWidgetIframeSrc({
        widget_name: 'order-confirmation',
        preview_mode,
        is_development,
        dev_port: 5176, // Order Confirmation uses port 5176
      });
    },

    sendSettingsToWidget,
    sendAutoFillTestData,
  },
};
</script>

<style scoped lang="scss">
.order-confirmation-preview-area {
  padding: 16px 16px 0 16px;
  flex-shrink: 0;
}
</style>